export default __webpack_public_path__ + "8968a4b8a454b9158ff4b5e6040f1672.svg";